
    var riot = require('riot')
    //src: starling/src/tags/modal-checkout-confirmation.html
riot.tag2('modal-checkout-confirmation',
  '<div class="Modal"> <header class="Modal_header"> <svg class="Modal_icon" style="fill: #80e5a2;"> <use xlink:href="#check_circle-icon"></use> </svg> <h2 class="Modal_title">Thank you for your order</h2> <button class="Modal_close" onclick="{hide}"> <svg class="Modal_close_icon"> <use xlink:href="#close-icon"></use> </svg> </button> </header> <p class="Modal_subtitle">Order number {orderKey}</p> <div if="{plan}" class="Modal_item"> <div class="Modal_item_details"> <h3 class="Modal_item_title">Plectica Pro</h3> <p class="Modal_item_tagline">{plan.billingInterval === \'annual\' ? \'Yearly\' : \'Monthly\'} subscription</p> <dl class="Modal_item_summary"> <dt class="Modal_item_summary_label">Total</dt> <dd class="Modal_item_summary_value">${plan.price}.00</dd> </dl> </div> </div> <footer class="Modal_footer"> Questions about your order? Contact our team at <a href="mailto:orders@plectica.com" class="Modal_footer_link">orders@plectica.com</a>. </footer> </div>',
  '',
  'show="{isVisible}" class="Modal_overlay"', function(opts) {
"use strict";

var _this = this;

var _opts = opts,
    canvas = _opts.canvas;

canvas.modalConfirmation = this;

this.show = function (_ref) {
  var orderKey = _ref.orderKey,
      planId = _ref.planId;

  _this.orderKey = orderKey;
  _this.plan = window.subscriptionProducts[planId];
  _this.isVisible = true;
  _this.update();
};

this.hide = function () {
  _this.isVisible = false;
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-checkout-confirmation')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-checkout-confirmation.html
// module id = 746
// module chunks = 0